module.exports = __webpack_public_path__ + "img/chargingpoint-realized.3d608dc2.svg";